module.exports = __webpack_public_path__ + "static/media/logo.5e5f1d31.svg";